import { Page, PageTitle } from "@/components/page"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { DataTable } from "@/components/datatable/datatable"
import { ToolbarItem } from "@/components/datatable/toolbaritem"
import { useTableController } from "@/components/datatable/controller"
import { useDatabaseData, usePage } from "@/components/page/hooks"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Download, ScrollText } from "lucide-react"
import { useEffect, useState } from "react"
import { downloadChangeMarkdown } from "./download"

export const agentsChangelog = {
  title: "Agents Changelog",
  description: "Audit log of changes made to your organization's agents.",
  route: "/settings/agents-changelog",
  url: "/settings/agents-changelog",
  icon: ScrollText,
  component,
  group: "settings",
  resource: "agents",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"agents_changelog">> = {
  title: { header: "Title", size: 500 },
  agent: { header: "Agent", size: 240, cell: ({ row }) => row.original.agent?.["title"] },
  author: { header: "Author", size: 240, cell: ({ row }) => row.original.author?.["email"] },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const { team } = usePage()
  const { data: agents } = useDatabaseData("agents", { fields: ["id", "title"], filter: q => q.eq("team_id", team?.id).or("status.is.null,status.neq.archived") })
  const [agentFilter, setAgentFilter] = useState<number | null>(null)
  const ctrl = useTableController()

  const filterLabel = agents?.find((a: any) => a.id === agentFilter)?.title || "<All>"

  useEffect(() => { ctrl.reload() }, [agentFilter])

  const menu: DropdownMenuContents = [
    { title: "Download", icon: <Download className="h-4 w-4" />, action: async (v) => downloadChangeMarkdown(v.title, v.document) },
  ]

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <PageTitle />
      <DataTableSupabase
        table="agents_changelog"
        columns={columns}
        showSelection
        onRowClick={"/settings/agents-changelog"}
        sort={["created_at", "desc"]}
        actions={menu}
        controller={ctrl}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
        filter={q => { q.eq("team", team?.id); if (agentFilter != null) q.eq("agent", agentFilter); return q }}
        select={`
        *,
        agent (
          title
        ),
        author (
          email
        )
        `}
      >
        <ToolbarItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <span className="text-sm cursor-pointer hover:text-blue-500 whitespace-nowrap">Show {filterLabel}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => setAgentFilter(null)}>&lt;All&gt;</DropdownMenuItem>
              {agents?.map((a: any) => (
                <DropdownMenuItem key={a.id} onClick={() => setAgentFilter(a.id)}>{a.title}</DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </ToolbarItem>
      </DataTableSupabase>
    </div>
  </Page>
}
